import Cookies from 'js-cookie';
import './retailer-selector.scss';


// Function to open retailer selector panel.
function openRetailerPanel() {
  document.querySelectorAll('.retailer-selector-content').forEach(panel => {
    panel.classList.add('open');
    panel.style.display = 'block';
  });
  document.getElementById('retailer-selector-overlay').style.display = 'block';
  document.body.classList.add('prevent-scroll');
}

// Function to close retailer selector panel.
function closeRetailerPanel() {
  document.querySelectorAll('.retailer-selector-content').forEach(panel => {
    panel.classList.remove('open');
    panel.style.display = 'none';
  });
  document.getElementById('retailer-selector-overlay').style.display = 'none';
  document.body.classList.remove('prevent-scroll');
}

// Function to check if retailer panel is open.
function isRetailerPanelOpen() {
  return document.querySelector('.retailer-selector-content.open') !== null;
}

// retailer / coop selector toggle.
document.querySelectorAll(".retailer-selector-toggle").forEach(toggle => {
  toggle.onclick = (event) => {
    if (!Cookies.get('visitor_retailer')) {
      return;
    }
    event.preventDefault();

    if (isRetailerPanelOpen()) {
      closeRetailerPanel();
    } else {
      openRetailerPanel();
    }
  };
});

// Close retailer panel when clicking on overlay (outside panel).
const retailerOverlay = document.getElementById('retailer-selector-overlay');
if (retailerOverlay) {
  retailerOverlay.addEventListener('click', (event) => {
    event.preventDefault();
    closeRetailerPanel();
  });
}

window.addEventListener('load', function () {

  triggerActiveRetailler();
  toggleCurrent();

  const retailerSelector = document.querySelector('.node--type-detaillant .retailer__selector');
  if (retailerSelector) {
    retailerSelector.addEventListener('click', function (e) {
      e.preventDefault();

      const retailerId = retailerSelector.getAttribute('data-retailer-id');
      //if cookie value is the same as the current detailed retailer, means he want to remove it as is favorite retailer.
      if (Cookies.get("visitor_retailer") === retailerId) {
        Cookies.remove('visitor_retailer');
        toggleRetailerLabel();
      } else {
        Cookies.set("visitor_retailer", retailerId);
        toggleRetailerLabel('active');
        getSelectedRetaillerInfo(Cookies.get("visitor_retailer"));
      }
    });
  }

});

function toggleCurrent() {
  if (document.querySelector('.node--type-detaillant .choose-retailer-section')) {
    const retailerSelector = document.querySelector('.node--type-detaillant .choose-retailer-section');
    retailerSelector.addEventListener('click', (e) => {
      const target = e.target.closest('.retailer__selector');
      if (target.classList.contains('current')) {
        retailerSelector.classList.add('current');
      } else {
        retailerSelector.classList.remove('current');
      }
    });
  }
}

function triggerActiveRetailler() {
  if (Cookies.get("visitor_retailer")) {
    toggleRetailerLabel('active');
    getSelectedRetaillerInfo(Cookies.get("visitor_retailer"));
  } else {
    toggleRetailerLabel();
  }
}

function toggleRetailerLabel($type) {
  const retailerSelectorLabel = document.querySelector('a.currentRetailerLabel');
  const retailerSelectorActive = document.querySelector('a.currentRetailerLabel.activeRetailerLabel');
  if ($type === 'active') {
    retailerSelectorLabel.classList.remove('active');
    retailerSelectorActive.classList.add('active');
  } else {
    retailerSelectorActive.classList.remove('active');
    retailerSelectorLabel.classList.add('active');
  }
}

function getSelectedRetaillerInfo(retailerID) {
  makeAjaxCall(retailerID);
}

//make the ajax request
const makeAjaxCall = (retailerID) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', Drupal.url('sollio_core/ajax/selected-retailer-response/') + retailerID, true);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);
      ajaxSuccessManipulation(response)
    }
  };
  xhr.send();
}

function ajaxSuccessManipulation(response) {

  const retailerDetailsLabel = document.querySelector('.retailer-section .retailerDetailsLabel');
  const retailerDetailsPage = document.querySelector('.retailer-section .retailerDetailsPage');
  const retailerDetailsPageContact = document.querySelector('.retailer-section .retailerDetailsPageContact');
  const currentRetailerLink = document.querySelector('.menu-secondary .currentRetailerLabel');
  const currentRetailerLabel = document.querySelector('.retailer-selector-content .currentRetailerLabel');
  const currentTitle = document.querySelector('.node--type-detaillant .retailer_title');
  const retailerSelector = document.querySelector('.node--type-detaillant .choose-retailer-section');

  currentRetailerLabel.href = currentRetailerLink.href;


  if (currentTitle && currentTitle.textContent === response.title) {
    retailerSelector.classList.add('current');
  }


  retailerDetailsLabel.textContent = response.title;
  retailerDetailsPage.addEventListener('click', function () {
    window.location.href = response.url;
  });
  retailerDetailsPageContact.addEventListener('click', function () {
    window.location.href = response.url + '/#contact';
  });
}
